export default class DetailsErrorController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    error
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.error = error.data;
  }

  hide() {
    this.$mdDialog.hide();
  }
}
